import React, { useState, useEffect } from "react";
import { Turtle, Upload } from "lucide-react";
import "./ProductDetails.css";
import BaseButton from "../Common/BaseButton";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ProductBenefits = ({ initialBenefits = [], handleProductRegenerate, loading, handleManualEdit, onHide, sectionId, sectionTitle, isHidden, onUnhide}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [benefits, setBenefits] = useState([]);
  useEffect(() => {
    if (initialBenefits) {
      let formattedBenefits = [];
  
    
      if (typeof initialBenefits === "object" && !Array.isArray(initialBenefits)) {
        formattedBenefits = Object.entries(initialBenefits).map(([key, value], index) => ({
          id: index + 1,
          text: value,
          icon: "",
        }));
      } else if (Array.isArray(initialBenefits)) {
       
        formattedBenefits = initialBenefits.map((text, index) => ({
          id: index + 1,
          text,
          icon: "",
        }));
      }
  
      setBenefits(formattedBenefits);
    }
  }, [initialBenefits]);
  
  const handleAddBenefit = () => {
    setBenefits([
      {
        id: benefits.length + 1,
        text: "New benefit",
        icon: "",
      },
      ...benefits,
    ]);
  };

  const handleDoneClick = () => {
    setIsEditing(false);
    handleManualEdit("highlights", benefits.map(b => b.text));
  };

  const handleBenefitTextChange = (id, newText) => {
    setBenefits((prevBenefits) =>
      prevBenefits.map((benefit) =>
        benefit.id === id && benefit.text !== newText
          ? { ...benefit, text: newText }
          : benefit
      )
    );
  };
  const handleRegenerate = async (type, formData, prev) => {
    let furtherDetailsToSend = "";
    let customPromptToSend = null;

    if (typeof formData === "object" && formData !== null) {
      if (formData.reason && formData.reason.trim() !== "") {
        furtherDetailsToSend = formData.reason;
        customPromptToSend = null;
      } else {
        furtherDetailsToSend = "";
        customPromptToSend = {
          goal: formData.goal,
          role: formData.role,
          constraints: formData.constraints,
        };
      }
    }
    else if (typeof formData === "string") {
      furtherDetailsToSend = formData;
      customPromptToSend = null;
    }

    await handleProductRegenerate(type, furtherDetailsToSend, prev, customPromptToSend);
  };
  return (
    <div className="product-section">
      {/* Header Section */}
      <div className="section-header">
        <div className="section-title">Product benefit highlight</div>
   {loading ?(<></>):(<> {!isEditing? (
        <div className="button-group">
          <BaseButton
            className="outlineprimary"
            children="Regenerate Text"
            imageSrc="/regenerate-text.svg"
            isModalOpen={true}
            handleClick={(formData) => handleRegenerate("highlights", formData, benefits.map(b => b.text).join('\n'))}
          />
          {isHidden && onUnhide ? (
            <BaseButton
              className="outlineprimary"
              children="Unhide Section"
              handleClick={onUnhide}
            />
          ) : onHide ? (
            <BaseButton
              className="outlineprimary"
              children="Hide Section"
              handleClick={() => onHide(sectionId, sectionTitle)}
            />
          ) : null}
          <BaseButton
            className="outlineprimary btn-sm"
            children="Edit Text"
            imageSrc="/edit-text.svg"
            handleClick={() => setIsEditing(true)}
          />
        </div>
      ):(
         <button
              className="btn btn-dark rounded px-4"
              onClick={() => handleDoneClick()}
            >
              Done
            </button>)} </>)}   
        
      </div>

      {/* Editable Mode */}
      {isEditing ? (
        <div>
          <div className="edit-benefits-header">
            <div className="d-flex align-items-center gap-2">
            <button className="bgprimary btn mt-3" onClick={handleAddBenefit}>
            Add another benefit
          </button>
            </div>
            {/* <div className="text-actions">
                      <BaseButton
                        className="outlineprimary"
                        imageSrc="/regenerate-text.svg"
                        children={"Regenerate Text"}
                        isModalOpen={true}
                        handleClick={(formData) => handleRegenerate("highlights", formData, benefits.map(b => b.text).join('\n'))}  
                      />
                    </div> */}
           
          </div>

          {/* Benefits Editing */}
          <div className="benefits-edit-container">
            {benefits.map((benefit, index) => (
              <div key={benefit.id} className="benefit-edit-item">
                {/* <div className="benefit-number">{index + 1}</div> */}
                <div className="benefit-edit-content">
                  {/* <div className="icon-section">
                    <div className="benefit-circle"></div>
                    <div className="icon-actions">
                      <BaseButton
                        className="outlineprimary"
                        imageSrc="/regenerate-image.svg"
                        children={"Regenerate Image"}
                        handleClick={() => console.log("Regenerating image...")}
                      />
                      <button className="outlineprimary btn">
                        <Upload size={16} />
                        <span>Upload Image</span>
                      </button>
                    </div>
                  </div> */}
                  <div className="text-section">
                    <input
                      type="text"
                      value={benefit.text}
                      onChange={(e) =>
                        handleBenefitTextChange(benefit.id, e.target.value)
                      }
                      className="form-control "
                    />
                   
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Add More Benefits Button */}
         
        </div>
      ) : (
        <div className="benefits-grid">
          {loading ? (
             [...Array(6)].map((_, index) => (
              <div key={index} style={{ padding: "10px",height :"12px", backgroundColor: "#f5f5f5", borderRadius: "6px", display: "flex", alignItems: "center" }}>
                <Skeleton height={10} width="60%" style={{ marginBottom: "5px", flex: 1 }} />
              </div>
            ))
          ) : (
            benefits.map((benefit) => ( 
              <div key={benefit.id} className="benefit-item">
                <div className="benefit-circle"></div>
                <span className="benefitText">{benefit.text}</span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default ProductBenefits;

